module.exports = __webpack_public_path__ + "static/media/testen-er-ferdig.e57afa92.mp3";